<template>
  <div class="content">
    <div class="bg">
      <a-form ref="formRef" name="advanced_search" class="ant-advanced-search-form" :model="serState"
        @finish="onFinish">
        <a-row :gutter="24">
          <a-col :span="4">
            <a-form-item label="基站ID">
              <a-input v-model:value="serState.stationNo" placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="基站名称">
              <a-input v-model:value="serState.name" placeholder="请输入"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="电池状态">
              <a-select v-model:value="serState.dczt" style="background-color: transparent">
                <a-select-option value="请选择">请选择</a-select-option>
                <a-select-option value="Sign Up">正常</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="分组">
              <a-select v-model:value="serState.groupId">
                <a-select-option value="请选择">请选择</a-select-option>
                <a-select-option value="Sign Up">正常</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-form-item label="城市">
              <a-select v-model:value="serState.cityId">
                <a-select-option value="请选择">请选择</a-select-option>
                <a-select-option value="Sign Up">正常</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="4">
            <a-button type="primary" html-type="submit" @click="getData(1, 10)">搜索
            </a-button>
          </a-col>
        </a-row>
        <a-row style="margin-bottom:20px">
          <a-col :span="12">
            <h1 class="jzlb">基站列表</h1>
          </a-col>
          <a-col :span="12" style="text-align: right">
            <!-- <a-button type="primary" html-type="submit">批量设置</a-button> -->
            <a-button style="margin: 0 8px" @click="showModal">添加基站</a-button>
            <a-button style="margin: 0 8px" @click="showModal3">添加城市</a-button>

            <a-dropdown>
              <a-button style="margin: 0 8px">分组管理</a-button>
              <template #overlay>
                <a-menu>
                  <a-menu-item>

                    <a @click="showModal2">添加分组</a>
                  </a-menu-item>
                  <a-menu-item>
                    <a @click="showModal3">分组列表</a>
                  </a-menu-item>

                </a-menu>
              </template>
            </a-dropdown>
            <a-button type="primary" style="margin: 0 8px">导出</a-button>
          </a-col>
        </a-row>
      </a-form>


      <a-table :columns="columns" :data-source="data" style="background-color: transparent !important; color: #fff">
        <template #headerCell="{ column }">
          <template v-if="column.key === 'name'">
            <span>
              {{ column.name }}
            </span>
          </template>
        </template>

        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'name'">
            {{ record.name }}
          </template>

          <template v-else-if="column.key === 'action'">
            <span>
              <a @click="xiangqing(record.id)">详情</a>
            </span>
            <span>
              <a @click="showModal"> 编辑</a>
            </span>
          </template>
        </template>
      </a-table>
      <a-pagination :total="pagination.total" :pageSize="pagination.pageSize" responsive :current="pagination.current"
        :hideOnSinglePage="true" :position="[bottomRight]" />
    </div>
  </div>

  <a-modal v-model:visible="visible" width="600px" title="基站设置" @ok="handleOk" cancelText="取消" okText="确定" :bodyStyle="{
    color: '#fff',
    background: '#0d2a4b',
    borderbottom: '1px #2b85e4 solid',
  }">
    <div style="width: 80%">
      <a-form :model="addjizhan" name="basic" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" autocomplete="off">
        <a-form-item label="所属城市">
          <a-input v-model:value="addjizhan.cityName" />
        </a-form-item>

        <a-form-item label="分组">
          <a-input v-model:value="addjizhan.groupId" />
        </a-form-item>
        <a-form-item label="基站ID">
          <a-input v-model:value="addjizhan.stationNo" />
        </a-form-item>

        <a-form-item label="基站名称">
          <a-input v-model:value="addjizhan.name" />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>

  <a-modal v-model:visible="visible2" width="600px" title="分组设置" @ok="handleOk2" cancelText="取消" okText="确定" :bodyStyle="{
    color: '#fff',
    background: '#0d2a4b',
    borderbottom: '1px #2b85e4 solid',
  }">
    <div style="width: 80%">
      <a-form :model="formState2" name="basic" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" autocomplete="off"
        @finish="onFinish2" @finishFailed="onFinishFailed">

        <a-form-item label="分组" name="group">
          <a-input v-model:value="group" />
        </a-form-item>

      </a-form>
    </div>
  </a-modal>

  <a-modal v-model:visible="visible_edit_group" width="600px" title="修改分组" @ok="handleOk_edit_group" cancelText="取消"
    okText="确定" :bodyStyle="{
      color: '#fff',
      background: '#0d2a4b',
      borderbottom: '1px #2b85e4 solid',
    }">
    <div style="width: 80%">
      <a-form name="basic" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" autocomplete="off">

        <a-form-item label="分组" name="group">
          <div style="display:none">
            <a-input v-model:value="groupid" />
          </div>
          <a-input v-model:value="edit_group" />
        </a-form-item>

      </a-form>
    </div>
  </a-modal>

  <a-modal v-model:visible="visible3" width="600px" title="分组列表" @ok="handleOk3" cancelText="取消" okText="确定" :bodyStyle="{
    color: '#fff',
    background: '#0d2a4b',
    borderbottom: '1px #2b85e4 solid',
  }">
    <div style="width: 100%">
      <a-form name="basic" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" autocomplete="off">

        <div style="display:flex;justify-content:space-between;width: 100%;margin-bottom: 10px;"
          v-for="(item, index) in grouplist" :key="index">
          <div style="color:#fff">{{ item.name }}</div>
          <div style="color:#fff"><a style="color:#ffff00" @click="editjz({ id: item.id, name: item.name })">编辑</a> | <a
              style="color:#ffff00" @click="deljz(item.id)">删除</a></div>
        </div>

      </a-form>
    </div>
  </a-modal>
</template>

<script>
import { message } from 'ant-design-vue';
import http from "@/api/http";
import { defineComponent, reactive, ref, onMounted } from "vue";
import { useStore } from "vuex";
import router from "@/router";
const pagination = ref({
  current: 1,
  pageSize: 10,
  total: 0,
})
const columns = [
  {
    title: "所属城市",
    dataIndex: "cityName",
    key: "cityName",
  },
  {
    title: "分组",
    dataIndex: "groupId",
    key: "groupId",
  },
  {
    title: "基站ID",
    dataIndex: "stationNo",
    key: "stationNo",
  },
  {
    title: "基站名称",
    key: "jzname",
    dataIndex: "name",
  },
  {
    title: "电池SOC",
    dataIndex: "dianchi",
    key: "dianchi",
  },
  {
    title: "当日储能度数",
    dataIndex: "dushu",
    key: "dushu",
  },
  {
    title: "剩余备电时长",
    dataIndex: "shichang",
    key: "shichang",
  },
  {
    title: "上一日节省电费",
    dataIndex: "dianfei",
    key: "dianfei",
  },
  {
    title: "电池状态",
    key: "dczt",
    dataIndex: "dczt",
  },
  {
    title: "操作",
    key: "action",
  },
];
const data = ref([]);

export default defineComponent({
  name: "JiZhan",
  components: {},
  props: {},
  setup() {
    const store = useStore()
    const list = ref([]);

    const expand = ref(true);
    const formRef = ref();
    const formState = reactive({});
    const group = ref();
    const edit_group = ref();
    const groupid = ref();
    const grouplist = ref();

    const addjizhan = reactive({
      name: "",
      stationNo: "",
      cityName: "",
      groupId: ""
    });

    const serState = reactive({
      name: "",
      stationNo: "",
      cityId: "",
      groupId: "",
      dczt: ""
    });



    const onFinish = (values) => {
      console.log("Received values of form: ", values);
      console.log("formState: ", formState);
    };

    const visible = ref(false);
    const visible2 = ref(false);
    const visible3 = ref(false);
    const visible_edit_group = ref(false);


    const showModal = () => {
      visible.value = true;
    };
    const showModal2 = () => {
      visible2.value = true;
    };
    const showModal3 = () => {
      http.get("/base_station_group").then((res) => {
        grouplist.value = res.data.records
      });
      visible3.value = true;
    };


    const handleOk = () => {

      http.put("/base_station", { params: addjizhan.value }).then(() => {
        message.success('提交成功');

      });

      visible.value = false;

    };
    const handleOk3 = () => {

      visible3.value = false;
    };
    const handleOk_edit_group = () => {
      http.put("/base_station_group", { name: edit_group.value, id: groupid.value }).then(() => {
        message.success('提交成功');

      });
      visible_edit_group.value = false;
    };
    const deljz = (e) => {
      http.delete("/base_station_group/" + e).then(() => {
        message.success('删除成功');

      });
      visible3.value = false;
    };
    const editjz = (e) => {
      visible3.value = false;
      visible_edit_group.value = true
      edit_group.value = e.name
      groupid.value = e.id
    };
    const handleOk2 = () => {

      http.post("/base_station_group", { name: group.value }).then(() => {
        message.success('提交成功');

      });
      visible2.value = false;
    };

    const formState2 = reactive({
      username: "",
      password: "",
      remember: true,
    });

    const getData = () => {
      http.get("/base_station?pageNum=" + pagination.value.current + "&pageSize=" + pagination.value.pageSize + "&cityId=1486").then((res) => {
        if (res.code == 1) {
          data.value = res.data.records
          pagination.value.total = res.data.total;
          pagination.value.pageSize = res.data.size;
          pagination.value.current = res.data.current;
        }

      });
    };
    const xiangqing = (e) => {
      //写入参数id
      store.dispatch('User/setstationid', e)
      router.push('/detail')

    }

    onMounted(() => {
      //组件挂载时的生命周期执行的方法


      getData();
    });

    return {
      handleOk3,
      xiangqing,
      deljz,
      editjz,
      list,
      getData,
      group,
      groupid,
      edit_group,
      visible_edit_group,
      grouplist,
      formRef,
      formState,
      expand,
      onFinish,
      value1: ref("请选择"),
      data,
      columns,
      visible,
      showModal,
      showModal3,
      visible3,
      handleOk,
      visible2,
      showModal2,
      handleOk2,
      handleOk_edit_group,
      formState2,
      pagination, addjizhan, serState
    };
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lange="less">
.content {
  padding: 0 40px;
  background: url("@/assets/bg22.png");
  height: 100%;
}

#app {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
  background-color: #000b23 !important;
  background: url("@/assets/bg.jpg") !important;

}

.bg {
  background-color: rgb(3, 28, 55, 0.8);
  padding: 20px 30px;
}

.jzlb {
  background: url("@/assets/biaoti.png") no-repeat;

  margin-top: 12px;
  font-weight: bold;
  padding-left: 30px;
  font-size: 14px;
  color: #fff;
  width: 288px;
}

.ant-input {
  color: #333 !important
}

.ant-table {
  background-color: transparent !important;
}

.ant-table a {
  color: #ffff00;
}

.ant-form-item-label>label {
  color: #fff !important;
}

.ant-table-thead>tr>th {
  background-color: #333 !important;
}
</style>
